import classNames from 'classnames'

import styles from './CoolHeader.module.scss'

type Props = {
  children: string
  hasBottomSection?: boolean
}

const CoolHeader = ({ children, hasBottomSection }: Props) => (
  <div className={classNames(styles.container, 'card shadow-sm', { 'mb-0': hasBottomSection })}>
    <h3 className='m-2' dangerouslySetInnerHTML={{ __html: children }} />
  </div>
)

export default CoolHeader
